/**
 * Configuración por cliente para el módulo Metricas.
 *
 * Para agregar un nuevo cliente, copiar el bloque 'banco-de-chile'
 * y ajustar: name, logo, canales, servicios, filtros y colores.
 */
const CLIENT_CONFIG = {
  'banco-de-chile': {
    name: 'Banco de Chile',
    logo: '/images/logos/bancochile_logo.svg',

    // IDs de canales del API
    canales: {
      web: { personas: 11, empresas: 12 },
      app: { personas: 21, empresas: 22 },
    },

    // Tipos de servicio para filtros de incidencias
    // Matches: "Mi Banconexión - TEF", "Emp - Transferencia de Fondos", "Pers - Transferencias a Terceros", etc.
    serviceTypes: [
      { key: 'Login', label: 'Login', pattern: /Login|Emergencia/i },
      { key: 'TEF', label: 'TEF', pattern: /TEF|Transferen/i },
    ],

    // Filtros de portal para incidencias
    // API names: "Mi Banconexión - ...", "Mi Banco 3.0 - ...", "Pers - ...", "Emp - ..."
    portals: [
      { key: 'Personas', label: 'Personas', pattern: /^(Pers\b|Mi Banco\b)/i },
      { key: 'Empresas', label: 'Empresas', pattern: /^(Emp\b|Mi Banconexión)/i },
    ],

    // Colores del tema
    colors: {
      primary: '#522C9D',
      primaryLight: '#F8F5FF',
      chartLine: '#522C9D',
      statusGreen: '#72F6AB',
      statBoxBg: '#EFF3FE',
      statBoxBgAlt: '#F8F5FF',
      tabIndicator: '#0A1938',
      toggleActiveBg: '#0A1938',
      toggleActiveText: '#FFFFFF',
      toggleInactiveText: '#424242',
      toggleBorder: '#0A1938',
      tableStripe: '#F8F5FF',
      incidentNumber: '#522C9D',
      cardBorder: '#E8E8E8',
      sectionIcon: '#522C9D',
      textPrimary: '#0A1938',
      textSecondary: '#9F9F9F',
      background: '#EEF3FE',
    },
  },
};

export const getClientConfig = (clientId = 'banco-de-chile') =>
  CLIENT_CONFIG[clientId] || CLIENT_CONFIG['banco-de-chile'];

export default CLIENT_CONFIG;
